import { IDocument } from 'wisestep-api';

const jobCandidateInteraction = {
  id: '',
  applicationStage: '',
  applicationState: '',
  candidateNotes: [{ notes: '', createdBy: '', createdAt: '' }],
  stageAndStateActions: [
    {
      stage: '',
      state: '',
      id: '',
      updatedBy: '',
      updatedOn: new Date().toString(),
    },
  ],
  stageDate: new Date().toString(),
  candidateId: '',
  name: '',
  page: 0,
  joiningDate: null,
  otherDocuments: [] as IDocument[],
  offeredPayRate: null,
  offeredPayRateCurrency: null,
  offeredPayRateTimeSpan: null,
};
export default jobCandidateInteraction;
